import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  constructor(private readonly http: HttpClient) {}

  getDisplayNames() {
    return this.http.get("display-names/");
  }

  getLabels() {
    const labels: any = localStorage.getItem("displayLabels");
    return JSON.parse(labels);
  }

  getOutlookFiles() {
    return this.http.get("nps/outlookfiles");
  }

  getLicensingImages(moduleName: string) {
    return this.http.get(`licensing-images/?module_name=${moduleName}`);
  }

  getMaxFileSize(): Observable<number> {
    const storedValue = localStorage.getItem("max_upload_file_size");

    if (storedValue) {
      return new Observable((observer) => {
        observer.next(Number(storedValue));
        observer.complete();
      });
    }

    return this.http.get<any>(`upload-file-max-size/`).pipe(
      map((res) => {
        const size = Number(res?.value || 50000000);
        localStorage.setItem("max_upload_file_size", size.toString());
        return size;
      })
    );
  }

  validateFileSize(file: File): Observable<boolean> {
    return this.getMaxFileSize().pipe(
      map((maxSize: number) => {
        if (file.size > maxSize) {
          return false;
        }
        return true;
      })
    );
  }
}
